function getConversationContextLabels(conversation) {
  var primaryObject = conversation && conversation.primaryObject
  var references = [primaryObject].concat(Array.isArray(conversation && conversation.objectRefs) ? conversation.objectRefs : [])
  var byType = {}

  references.forEach(function (reference) {
    if (!reference) return
    var type = String(reference.type || reference.objectType || '').toLowerCase()
    if (!type || byType[type]) return
    var label = String(reference.label || reference.name || '').trim()
    if (label) byType[type] = label
  })

  var primaryType = String(primaryObject && (primaryObject.type || primaryObject.objectType) || '').toLowerCase()
  var order = primaryType === 'activity'
    ? ['deal', 'contact', 'entity']
    : primaryType === 'deal'
      ? ['deal', 'entity']
      : primaryType === 'contact'
        ? ['contact', 'entity']
        : primaryType === 'entity'
          ? ['entity']
          : [primaryType]

  return order.map(function (type) { return byType[type] }).filter(Boolean)
}

export { getConversationContextLabels }
